"use client";

import { c as _c } from "react/compiler-runtime";
;
!function () {
  try {
    var e = "undefined" != typeof window ? window : "undefined" != typeof global ? global : "undefined" != typeof globalThis ? globalThis : "undefined" != typeof self ? self : {};
    e._sentryModuleMetadata = e._sentryModuleMetadata || {}, e._sentryModuleMetadata[new e.Error().stack] = Object.assign({}, e._sentryModuleMetadata[new e.Error().stack], {
      "_sentryBundlerPluginAppKey:propstrata-app": true
    });
  } catch (e) {}
}();
import { UserAvatar } from "@/components/shared/user-avatar";
export type UserAvatarWithDetailsProps = {
  email: string;
  userName: string;
  profilePicture?: string | null;
  className?: string;
  showUserName?: boolean;
  showEmail?: boolean;
};
export function UserAvatarWithDetails(t0) {
  const $ = _c(14);
  const {
    email,
    userName,
    profilePicture,
    className,
    showUserName: t1,
    showEmail: t2
  } = t0;
  const showUserName = t1 === undefined ? true : t1;
  const showEmail = t2 === undefined ? true : t2;
  const shouldShowTextBlock = showUserName || showEmail;
  let t3;
  if ($[0] !== className || $[1] !== email || $[2] !== profilePicture || $[3] !== userName) {
    t3 = <UserAvatar className={className} email={email} profilePicture={profilePicture} userName={userName} />;
    $[0] = className;
    $[1] = email;
    $[2] = profilePicture;
    $[3] = userName;
    $[4] = t3;
  } else {
    t3 = $[4];
  }
  let t4;
  if ($[5] !== email || $[6] !== shouldShowTextBlock || $[7] !== showEmail || $[8] !== showUserName || $[9] !== userName) {
    t4 = shouldShowTextBlock ? <div className="grid flex-1 text-left text-sm leading-tight">{showUserName ? <span className="truncate font-normal">{userName}</span> : null}{showEmail ? <span className="truncate text-[10px]">{email}</span> : null}</div> : null;
    $[5] = email;
    $[6] = shouldShowTextBlock;
    $[7] = showEmail;
    $[8] = showUserName;
    $[9] = userName;
    $[10] = t4;
  } else {
    t4 = $[10];
  }
  let t5;
  if ($[11] !== t3 || $[12] !== t4) {
    t5 = <>{t3}{t4}</>;
    $[11] = t3;
    $[12] = t4;
    $[13] = t5;
  } else {
    t5 = $[13];
  }
  return t5;
}